module.exports = __webpack_public_path__ + "static/stepper-gold-icon-ja-085786b671dbd4a0725d5b13598b999c.svg";